import { render, staticRenderFns } from "./phoneView.vue?vue&type=template&id=a8f5127c&scoped=true&"
import script from "./phoneView.vue?vue&type=script&lang=js&"
export * from "./phoneView.vue?vue&type=script&lang=js&"
import style0 from "./phoneView.vue?vue&type=style&index=0&id=a8f5127c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f5127c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2026/QianKunLong/QklAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8f5127c')) {
      api.createRecord('a8f5127c', component.options)
    } else {
      api.reload('a8f5127c', component.options)
    }
    module.hot.accept("./phoneView.vue?vue&type=template&id=a8f5127c&scoped=true&", function () {
      api.rerender('a8f5127c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sysconfig/styleConfig/phoneView.vue"
export default component.exports